const FIELD_OF = {
    first: 'firstName',
    middle: 'middleName',
    father: 'fatherOrHusbandName',
    last: 'lastName',
    secondLast: 'secondLastName',
};
export function fatherInFullName(profile) {
    return profile.code === 'SA';
}
export function composeFullName(profile, parts) {
    const order = profile.names.parts.includes('first') ? profile.names.parts : ['first', 'last'];
    const words = order
        .filter((part) => part !== 'father' || fatherInFullName(profile))
        .map((part) => parts[FIELD_OF[part]]?.trim())
        .filter((word) => Boolean(word));
    if (!profile.names.parts.includes('middle') && parts.middleName?.trim())
        words.splice(1, 0, parts.middleName.trim());
    return words.join(' ').replace(/\s+/g, ' ').trim();
}
export function nameFieldLabel(profile, part) {
    const defaults = {
        first: 'First name',
        middle: 'Middle name',
        father: 'Father / husband name',
        last: 'Last name',
        secondLast: 'Second last name',
    };
    return profile.names.labels[part] ?? defaults[part];
}
//# sourceMappingURL=names.js.map